<app-template [disablebreadcrumb]=true [fullLayout]="true" [footerVisible]="true">
  <div class="app-dashboard">
    <div class="p-grid p-fluid">
      <div class="p-col-12 p-xl-2 item-filter">
        <label>Resultado</label>
        <p-dropdown [options]="resultOptions"  (onChange)="loadChartsSelectedResult()"
          [(ngModel)]="filters.selectedResult" [autoDisplayFirst]="false"></p-dropdown>
      </div>
      <div class="p-col-12 p-xl-2 item-filter">
        <label>Origem</label>
        <p-dropdown [options]="originOptions"  (onChange)="handleOriginSelected()" [(ngModel)]="filters.selectedOrigin"
          [autoDisplayFirst]="false"  placeholder="All"></p-dropdown>
      </div>
      <div class="p-col-12 p-xl-2 item-filter">
        <label>Presencial</label>
        <p-multiSelect [options]="meetingListOptions" [(ngModel)]="filters.selectedMeeting" placeholder="Selecione"
          [disabled]="validateOriginSelectedPresential()" [filter]="true" (onChange)="loadCharts()">
        </p-multiSelect>
      </div>
      <div class="p-col-12 p-xl-6 refresh-filter">
        <div class="refresh-filter-container" (click)="clearFilters()">
          <i class="pi pi-refresh"></i>
          <span>Restaurar</span>
        </div>
      </div>
      <div class="p-col-12 card-indicators-container" *ngIf="dashboardData">
        <div class="card-indicator">
          <span>{{dashboardData.participants}}</span>
          <label>Participantes</label>
        </div>
        <div class="card-indicator">
          <span>{{dashboardData.proposals}}</span>
          <label>Propostas</label>
        </div>
        <div class="card-indicator">
          <span>{{dashboardData.highlights}}</span>
          <label>Destaques</label>
        </div>
        <div class="card-indicator">
          <span>{{dashboardData.counties}}</span>
          <label>Municípios</label>
        </div>
      </div>
      <div class="p-col-12">
        <div class="p-grid p-jc-between">
          <div class="p-col-12 p-xl-4">
            <div class="chart-container">
              <div class="p-grid chart-header">
                <div class="p-col-12 chart-navigation-header">
                  <div class="chart-title">
                    <span class="subtitle">{{chartsTitleSelected}} por Microrregião</span>
                  </div>
                  <div class="bar-navigation" *ngIf="barRegionSelecteds && barRegionSelecteds.length > 0">
                    <fa-icon [icon]="arrowLeftIcon" class="fas-icon" (click)="handleBackRegionChartClicked()"></fa-icon>
                    <span class="description">{{barRegionSelecteds[barRegionSelecteds.length - 1].description}}</span>
                  </div>
                </div>
                <div class="p-col-12 header-sub-description"
                  *ngIf="barStrategicAreaSelecteds && barStrategicAreaSelecteds.length > 0 && responsive">
                  <span>{{barStrategicAreaSelecteds[barStrategicAreaSelecteds.length - 1].description}}</span>
                </div>

                <div class="p-col-12 chart-params">
                  <div class="chart-param">
                    <label>Agrupar:</label>
                    <p-dropdown class="param" [options]="microregionChartAgroupOptions"
                      (onChange)="handleMicroregionChartAgroupClicked()" [autoDisplayFirst]="false"
                      [(ngModel)]="microregionChartAgroupSelected"></p-dropdown>
                  </div>
                  <div class="chart-param">
                    <label>Exibir:</label>
                    <p-dropdown class="param" (onChange)="handleDisplayModeMicroregionChartChange()"
                      [autoDisplayFirst]="false" [options]="chartDisplayOptions" [group]="true"
                      [(ngModel)]="microregionChartDisplaySelected">
                    </p-dropdown>
                  </div>
                </div>
              </div>
              <div class="header-sub-description"
                *ngIf="barStrategicAreaSelecteds && barStrategicAreaSelecteds.length > 0 && !responsive">
                <span>{{barStrategicAreaSelecteds[barStrategicAreaSelecteds.length - 1].description}}</span>
              </div>
              <div class="divisor" *ngIf="conference">
                <hr />
              </div>
              <div class="chart" *ngIf="dashboardData && showMicroregionChart && dashboardData.microregionChart">
                <app-horizontal-bar-graph [chartData]="dashboardData?.microregionChart"
                  (graphClicked)="handleMicroregionChartClicked($event)">
                </app-horizontal-bar-graph>
              </div>
              <div class="selected-bar-values" *ngIf="!showMicroregionChart">
                <span class="description">{{barRegionSelecteds[barRegionSelecteds.length - 1].description}}</span>
                <span class="value">{{barRegionSelecteds[barRegionSelecteds.length - 1].quantity}}</span>
              </div>
            </div>
          </div>
          <div class="p-col-12 p-xl-4">
            <div class="chart-container chart-heatmap-container">
              <div class="chart-header">
                <div class="chart-heatmap-title">
                  <span class="subtitle">{{chartsTitleSelected}}</span>
                </div>
                <div class="chart-pararms">
                  <div class="chart-param">
                  </div>
                </div>
              </div>
              <div class="chart-heatmap-divisor" *ngIf="conference">
                <hr />
              </div>
              <div class="chart-heatmap" *ngIf="dashboardData">
                <app-heat-map [locations]="dashboardData.heatMapChart" [center]="heatMapCenter" [zoom]="heatmapZoom">
                </app-heat-map>
              </div>
            </div>
          </div>
          <div class="p-col-12 p-xl-4">
            <div class="chart-container">
              <div class="p-grid chart-header">
                <div class="p-col-12 chart-navigation-header">
                  <div class="chart-title">
                    <span class="subtitle">{{chartsTitleSelected}} por Área Estratégica</span>
                  </div>
                  <div class="bar-navigation" *ngIf="barStrategicAreaSelecteds && barStrategicAreaSelecteds.length > 0">
                    <fa-icon [icon]="arrowLeftIcon" class="fas-icon" (click)="handleBackStrategicAreaChartClicked()">
                    </fa-icon>
                    <span class="description">{{barStrategicAreaSelecteds[barStrategicAreaSelecteds.length -
                      1].description}}</span>
                  </div>
                </div>
                <div class="p-col-12 header-sub-description"
                  *ngIf="barRegionSelecteds && barRegionSelecteds.length > 0 && responsive">
                  <span>{{barRegionSelecteds[barRegionSelecteds.length - 1].description}}</span>
                </div>
                <div class="p-col-12 chart-params">
                  <div class="chart-param">
                    <label>Exibir:</label>
                    <p-dropdown class="param" (onChange)="handleDisplayModeStrategicAreaChartChange()"
                      [autoDisplayFirst]="false" [options]="chartDisplayOptions" [group]="true"
                      [(ngModel)]="strategicAreaChartDisplaySelected">
                    </p-dropdown>
                  </div>
                </div>
              </div>
              <div class="header-sub-description"
                *ngIf="barRegionSelecteds && barRegionSelecteds.length > 0 && !responsive">
                <span>{{barRegionSelecteds[barRegionSelecteds.length - 1].description}}</span>
              </div>
              <div class="divisor">
                <hr />
              </div>
              <div class="chart" *ngIf="dashboardData && showStrategicAreaChart && dashboardData.strategicAreaChart">
                <app-horizontal-bar-graph [chartData]="dashboardData?.strategicAreaChart"
                  (graphClicked)="handleStrategicAreaChartClicked($event)">
                </app-horizontal-bar-graph>
              </div>
              <div class="selected-bar-values" *ngIf="!showStrategicAreaChart">
                <span class="description">{{barStrategicAreaSelecteds[barStrategicAreaSelecteds.length -
                  1].description}}</span>
                <span class="value">{{barStrategicAreaSelecteds[barStrategicAreaSelecteds.length - 1].quantity}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-template>
